import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import moment from 'moment';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { SetComponentLanguage, ApiRequest } from '../../helpers';
import Message from '../Common/Message/Message';
import Help from '../Common/Help/Help';
import SingleDatePickerWrapper from '../Common/SingleDatePickerWrapper/SingleDatePickerWrapper';
import en from './locales/en.json';
import fr from './locales/fr.json';

import './AccountBalance.css';
import { string } from 'prop-types';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class AccountBalance extends Component {
	constructor(props) {
        super(props);
        this.state = {
            message: {
                title: '',
                content: '',
                type: '',
            },
            date: '',
            total_balance: 0,
            active_balance: 0,
            donation_balance: 0,
            future_payout_balance: 0,
            in_transit_balance: 0,
            events: [],
            flexpasses: [],
            activeTab: 'active-funds',
            payouts: [],
            hasStripeConnect: false,
            payoutsCheck: [],
            maxCheck: 10,
            startCheck: 0,
            allEvents: [],
            client: {
                id: null,
                daily_email: false,
                client_name: '',
                client_email: '',
                client_phone: '',
                billing_contact: '',
                billing_address_1: '',
                billing_address_2: '',
                billing_city: '',
                billing_country: 'US',
                billing_state: 'AL',
                billing_zip: '',
                referred_by: '',
                donation: false,
                donation_text: '',
                donation_email: '',
                collect_cust_info: false,
                allow_will_call: false,
                allow_callcenter_refund: false,
                allow_callcenter_exchange: false,
                url_short_name: '',
                payout_option: 'check-at-close',
                payout_frequency: 'daily',
            },
            isPaymentDetailsOpen: false,
            selectedBill: -1,
            sort: 'createdTime',
            sortAsc: false,
            isModalLoading: false,
        };
    }
    
    componentDidMount() {
        this.getAccountBalances();
        this.getStripeURL();
        this.getEvents();
        this.getClient();
    }

    togglePaymentDetailsModal = () => {
        let isPaymentDetailsOpen = !this.state.isPaymentDetailsOpen;
        this.setState({
            isPaymentDetailsOpen,
            isModalLoading: false,
        });
    }

    getEvents = () => {
        (async () => {
            try {
                const eventsListResponse = await eventsList();
                console.log('events list response: ', eventsListResponse);

                if(eventsListResponse.data.events){
                    this.setMessage('','','');
                    
                    let allEvents = eventsListResponse.data.events.map(e => {
                        return {
                            id: e.id,
                            name: e.name,
                        }
                    });

                    this.setState({ 
                        allEvents,
                    });
                } else {
                    this.setMessage(window.general_strings.msg.oops, eventsListResponse.data.error.code,'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function eventsList() {
            return await ApiRequest(`/events`);
        }
    }

    getClient = () => {
        (async () => {
            try {
                const clientResponse = await client();
                console.log('clientResponse: ', clientResponse);

                if(clientResponse.data.client){
                    this.setMessage('','','');
                    let client = clientResponse.data.client;
                    
                    this.setState({ 
                        client,
                    });
                } else {
                    this.setMessage(window.general_strings.msg.oops, clientResponse.data.error.code,'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function client() {
            return await ApiRequest('/clients/current');
        }
    }

    getStripeURL = async () => {
        try {
            let hasStripeConnect = this.state.hasStripeConnect;
            const accountsResponse = await getAccounts();
            console.log('accountsResponse: ', accountsResponse);
            if (accountsResponse.data.stripe_accounts) {
                accountsResponse.data.stripe_accounts.forEach((account) => {
                    if (account.type === 'connect') {
                        hasStripeConnect = true;
                    }
                })
            }
            this.setState({
                hasStripeConnect,
            });
        } catch (error) {
            console.log(error);
        }

		async function getAccounts() {
			return await ApiRequest(`/clients/current/stripe-accounts`, {
                method: 'GET'
            });
        }
    }

    getAccountBalances = (client_id: Number) => {
        this.setMessage('', '', 'loading');
        let date = this.state.date;
        let today = new Date();
        today = today.toISOString().split('T')[0];
        if (date !== '') {
            if (date !== undefined) {
                date = date.toISOString().split('T')[0];
            } else {
                date = today;
            }
        }
        (async () => {
            try {
                const getBalancesResponse = await getBalances(client_id, date, today);
                console.log('getBalancesResponse: ', getBalancesResponse);
                if (getBalancesResponse.data.status === 'success') {
                    let active_balance = this.state.active_balance;
                    active_balance = getBalancesResponse.data.active_balance;

                    let future_payout_balance = this.state.future_payout_balance;
                    future_payout_balance = getBalancesResponse.data.future_payout_balance;

                    let donation_balance = this.state.donation_balance;
                    donation_balance = getBalancesResponse.data.donation_balance;

                    let total_balance = this.state.total_balance;
                    total_balance = getBalancesResponse.data.total_balance;

                    /*let in_transit_balance = this.state.in_transit_balance;
                    in_transit_balance = getBalancesResponse.in_transit_balance.total_balance;*/

                    let events = this.state.events;
                    if (getBalancesResponse.data.events) {
                        events = getBalancesResponse.data.events;
                    }

                    let flexpasses = this.state.flexpasses;
                    if (getBalancesResponse.data.flexpasses) {
                        flexpasses = getBalancesResponse.data.flexpasses;
                    }

                    this.setMessage('', '', '');

                    this.setState({
                        active_balance,
                        future_payout_balance,
                        donation_balance,
                        total_balance,
                        //in_transit_balance,
                        events,
                        flexpasses,
                    });
                } else {
                    this.setState({
                        events: [],
                    })
                    this.setMessage(window.general_strings.msg.oops, getBalancesResponse.data.status,'error');
                    setTimeout(() => {
                        this.setMessage('', '', '');
                    }, 5000);
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function getBalances(client_id, date, today) {
            let url = `/account-balances?`;
            if (today.toString() === date.toString()) {
                date = undefined;
            }
            if (date) {
                url += `&date=${date}`
            }
            /* 
            if (selectedPage) {
                url += `&page=${selectedPage}`
            }
            if (selectedLimit) {
                url += `&limit=${selectedLimit}`
            }
            if (selectedCountry) {
                url += `&country=${selectedCountry}`
            }
            if (selectedPayout) {
                url += `&payout_type=${selectedPayout}`
            } */

            url = url.replace('?&', '?');

            return await ApiRequest(url, {
                method: 'GET'
            });
        }
    }

    handleDayChange = (day, input) => {
		this.setState({
            date: day
		}, () => {
            this.getAccountBalances();
        });
	}

    handleStartDateChange = (day, input) => {
		this.setState({
            startDateCheck: day
		});
	}

    handleEndDateChange = (day, input) => {
		this.setState({
            endDateCheck: day
		});
	}

    handleMaxSelect = (e) => {
        const value = e.target.value;
        let maxCheck = this.state.maxCheck;
        maxCheck = value;
        this.setState({
            maxCheck,
        });
    }

    handleStartSelect = (e) => {
        const value = e.target.value;
        let startCheck = this.state.startCheck;
        startCheck = value;
        this.setState({
            startCheck,
        });
    }
    
    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }    

    getEventHistory = () => {
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/reports/event-account-history/csv`);
    }

    loadActiveFunds = () => {
        this.setState({
            activeTab: 'active-funds',
        });
    }

    loadPayouts = (index, direction) => {
        let limit = this.state.limit;
        let payouts = this.state.payouts;
        let payout_id_for_paging;
        if (index) {
            payout_id_for_paging = payouts[index-1].stripe_payout_id;
            if (direction < 0) {
                payout_id_for_paging = payouts[0].stripe_payout_id;
            }
        }
        this.setMessage('', '', 'loading');
        (async () => {
            try {
                const getPayoutsResponse = await getPayouts(limit, payout_id_for_paging, direction);
                console.log('getPayoutsResponse: ', getPayoutsResponse);
                if (!getPayoutsResponse.data.error) {
                    let payouts = this.state.payouts;
                    if (getPayoutsResponse.data.payouts.length > 0) {
                        payouts = getPayoutsResponse.data.payouts;
                        payouts.forEach((payout) => {
                            payout.isOpen = false;
                        });
                    }
                    this.setMessage('', '', '');
                    this.setState({
                        payouts,
                    });
                } else {
                    this.setState({
                        payouts: [],
                    });
                    //this.setMessage(window.general_strings.msg.oops, getPayoutsResponse.data.error.code,'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function getPayouts(limit, payout_id_for_paging, direction) {
            let url = `/stripe/payouts?`;
            if (limit) {
                url += `&limit=${limit}`
            }
            if (direction > 0) {
                url += `&payout_id_for_next=${payout_id_for_paging}`
            }
            if (direction < 0) {
                url += `&payout_id_for_previous=${payout_id_for_paging}`
            }
            url = url.replace('?&', '?');
            return await ApiRequest(url, {
                method: 'GET'
            });
        }

        this.setState({
            activeTab: 'payouts',
        });

        this.loadPayoutsCheck();
    }

    loadPayoutInfo = (payout, index) => {
        let payouts = this.state.payouts;
        if (payouts[index].isOpen) {
            payouts[index].isOpen = false;
            this.setState({
                payouts,
            });
        } else {
            this.setMessage('', '', 'loading');
            (async () => {
                try {
                    const getPayoutInfoResponse = await getPayoutInfo(payout.stripe_payout_id);
                    console.log('getPayoutInfoResponse: ', getPayoutInfoResponse);
                    if (!getPayoutInfoResponse.data.error) {
                        payouts[index] = getPayoutInfoResponse.data;
                        payouts[index].isOpen = true;
                        this.setMessage('', '', '');
                        this.setState(
                            {
                                payouts,
                            }, () => {
                                this.getEventInfo();
                            }
                        );
                    } else {
                        this.setMessage(window.general_strings.msg.oops, getPayoutInfoResponse.data.error.code,'error');
                    }
                } catch (error) {
                    console.log(error);
                }
            })()

            async function getPayoutInfo(stripe_payout_id) {
                let url = `/stripe/payouts/${stripe_payout_id}`;
                return await ApiRequest(url, {
                    method: 'GET'
                });
            }
        }
    }

    getPayoutCheck = (index) => {
        let selectedBill = index;
        let payoutsCheck = this.state.payoutsCheck;
        this.setMessage('', '', 'loading');
        if (!payoutsCheck[index].disbursementData) {
            (async () => {
                try {
                    const getPayoutCheckResponse = await getPayoutCheck(payoutsCheck[index].billPays[0].sentPayId);
                    console.log('getPayoutCheckResponse: ', getPayoutCheckResponse);
                    if (!getPayoutCheckResponse.data.error) {
                        payoutsCheck[index].disbursementData = getPayoutCheckResponse.data.disbursementData;
                        if (!payoutsCheck[index].disbursementData.checkData) {
                            payoutsCheck[index].disbursementData.checkData = {};
                            payoutsCheck[index].disbursementData.checkData.checkNumber = '';
                        }
                        this.setState({
                            selectedBill,
                            payoutsCheck,
                        }, () => {
                            if (payoutsCheck[index].disbursementData.disbursementStatus === 'cleared') {
                                this.getCheckImages(index);
                            }
                            this.setState({
                                isModalLoading: false,
                                isPaymentDetailsOpen: true,
                            });
                            this.setMessage('', '', '');
                        });
                    } else {
                        this.setState({
                            payoutsCheck: [],
                        });
                        //this.setMessage(window.general_strings.msg.oops, getPayoutsResponse.data.error.code,'error');
                    }
                } catch (error) {
                    console.log(error);
                    this.setMessage('', '', '');
                }
            })();
        } else {
            this.setState({
                selectedBill,
                payoutsCheck,
            }, () => {
                this.setState({
                    isModalLoading: false,
                    isPaymentDetailsOpen: true,
                });
                this.setMessage('', '', '');
            });
        }

        async function getPayoutCheck(sentPayId) {
            return await ApiRequest(`/bill-com/disbursement-data?sentPayId=${sentPayId}`, {
                method: 'GET'
            });
        }
    }

    loadPayoutsCheck = () => {
        let payoutsCheck = this.state.payoutsCheck;
        let max = this.state.maxCheck;
        let start = this.state.startCheck;
        this.setMessage('', '', 'loading');
        (async () => {
            try {
                const getPayoutsCheckResponse = await getPayoutsCheck(max, start);
                console.log('getPayoutsCheckResponse: ', getPayoutsCheckResponse);
                if (!getPayoutsCheckResponse.data.error) {
                    payoutsCheck = getPayoutsCheckResponse.data.payments;
                    this.setState({
                        payoutsCheck,
                    });
                    this.setMessage('', '', '');
                } else {
                    this.setState({
                        payoutsCheck: [],
                    });
                    //this.setMessage(window.general_strings.msg.oops, getPayoutsResponse.data.error.code,'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function getPayoutsCheck(max, start) {
            let url = `/bill-com/payments?`;
            if (max) {
                url += `&max=${max}`
            }
            if (start) {
                url += `&start=${start}`
            }
            url = url.replace('?&', '?');
            return await ApiRequest(url, {
                method: 'GET'
            });
        }

        this.setState({
            activeTab: 'payouts',
        });
    }

    getBill = (payment_index) => {
        let selectedBill = payment_index;
        let payoutsCheck = this.state.payoutsCheck;
        let billPays = payoutsCheck[payment_index].billPays;
        this.setState({
            isModalLoading: true,
        });
        this.setMessage('', '', 'loading');
        billPays.forEach(async (billPay) => {
            if (!billPay.bill) {
                const billPayResponse = await getBill(billPay.billId);
                console.log('billPayResponse', billPayResponse); 
                if (billPayResponse.data.bill) {
                    billPay.bill = billPayResponse.data.bill;
                } else {
                    billPay.bill = {};
                    billPay.bill.billLineItems = [];
                    this.setMessage('', '', '');
                }

                this.setState({
                    payoutsCheck,
                }, () => {
                    this.getPayoutCheck(payment_index);
                });

                async function getBill(billId) {
                    let url = `/bill-com/bill?`;
                    if (billId) {
                        url += `&billId=${billId}`
                    }
                    url = url.replace('?&', '?');
                    return await ApiRequest(url, {
                        method: 'GET'
                    });
                }
            } else {
                this.setState({
                    payoutsCheck,
                    selectedBill,
                }, () => {
                    this.getPayoutCheck(payment_index);
                });
            }
        });
        //this.getPayoutCheck(payment_index);
    }

    getCheckImages = (payment_index) => {
        let payoutsCheck = this.state.payoutsCheck;
        //let billPays = payoutsCheck[payment_index].billPays;
        this.setMessage('', '', 'loading');

        (async () => {
            try {
                if (!payoutsCheck[payment_index].images) {
                    const getImagesResponse = await getImages(payoutsCheck[payment_index].id);
                    console.log('getImagesResponse', getImagesResponse); 
                    if (getImagesResponse.data.urls) {
                        payoutsCheck[payment_index].images = getImagesResponse.data.urls;
                    }

                    this.setMessage('', '', '');
                    this.setState({
                        payoutsCheck,
                    });
                }
            } catch (error) {
                console.log(error);
            }
        })();

        async function getImages(sentPayId) {
            let url = `/bill-com/check-image-urls?`;
            if (sentPayId) {
                url += `&sentPayId=${sentPayId}`
            }
            url = url.replace('?&', '?');
            return await ApiRequest(url, {
                method: 'GET'
            });
        }
    }

    getEventInfo = () => {
        const payouts = this.state.payouts;
        payouts.forEach((payout) => {
            if (payout.withdrawals) {
                payout.withdrawals.forEach(async (withdrawal) => {
                    if (withdrawal.event_id !== 0) {
                        const eventResponse = await get_event(withdrawal.event_id);
                        console.log('eventResponse', eventResponse);   
        
                        if(eventResponse.data.event){
                            withdrawal.event_name = eventResponse.data.event.name;
                            withdrawal.event_type = 'event';
                        }
                    }

                    if (withdrawal.flexpass_id !== 0) {
                        const flexpassResponse = await get_flexpass(withdrawal.flexpass_id);
                        console.log('flexpassResponse', flexpassResponse);   
        
                        if(flexpassResponse.data.flexpass){
                            withdrawal.event_name = flexpassResponse.data.flexpass.name;
                            withdrawal.event_type = 'flexpass';
                        }
                    }

                    console.log('payouts', payouts)

                    this.setState({
                        payouts,
                    });
    
                    async function get_event(event_id) {
                        return await ApiRequest(`/events/${event_id}`, {
                            method: 'GET'
                        });
                    }

                    async function get_flexpass(flexpass_id) {
                        return await ApiRequest(`/flexpass/${flexpass_id}`, {
                            method: 'GET'
                        });
                    }
                });
            }
        });
    }

    getPayoutDetails = (stripe_payout_id) => {
        (async () => {
            try {
                const getPayoutDetailsResponse = await getPayoutDetails(stripe_payout_id);
                console.log('getPayoutDetailsResponse: ', getPayoutDetailsResponse);
                if (!getPayoutDetailsResponse.data.error) {
                    

                    this.setMessage('', '', '');

                    /* this.setState({
                        payouts: getPayoutDetailsResponse.data.payouts,
                    }); */
                } else {
                    this.setState({
                        payouts: [],
                    })
                    this.setMessage(window.general_strings.msg.oops, getPayoutDetailsResponse.data.error.code,'error');
                }
            } catch (error) {
                console.log(error);
            }
        })();

        async function getPayoutDetails(stripe_payout_id) {
            let url = `/stripe/payouts/${stripe_payout_id}`;
            return await ApiRequest(url, {
                method: 'GET'
            });
        }
    }

    getDonationsReport = () => {
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/reports/donation-account-history/csv`);
    }

    getAccountEventReport = async (e, ticketType) => {
        const routePath = (ticketType && ticketType === 'flexpass') ? 'flexpass-account/pdf?flexpass_id=' : 'event-account/pdf?event_id=';
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/reports/${routePath}${e}`);
    }

    sort = (type) => {
        let payoutsCheck = this.state.payoutsCheck;
        let sortAsc = this.state.sortAsc;
        payoutsCheck.sort((a, b) => {
            if (a[type] < b[type]) {
              return -1;
            }
            if (a[type] > b[type]) {
              return 1;
            }
            return 0;
        });
        if (sortAsc) {
            payoutsCheck.reverse();
        }
        sortAsc = !sortAsc;
        this.setState({
            sort: type,
            payoutsCheck,
            sortAsc,
        });
    } 

    renderW9Message = () => {
        const client = this.state.client;
        if (client.billing_country === 'US' && !client.tax_1099_received) {
            let message = {
                title: 'Warning',
                content: '<p>Our records indicate we do not have a W9 on file for your organization. Before payment can be sent, we will need this informational tax document. This is required even for non-profit, tax exempt, and government entities.</p><p>To ensure a secure platform and to comply with federal tax regulations, we are required to have your organization\'s W9. For more information on why a W9 is needed and how it is used visit: <a href="https://showtix4u.zendesk.com/hc/en-us/articles/360055496972-Arts-Organization-Why-do-you-need-a-W9-and-where-do-I-submit-it-?" target="_blank">Arts Organization > Why do you need a W9 and where do I submit it?</a></p>',
            }
            return (
                <React.Fragment>
                    <div className="row">
                        <div className="col-12">
                            <Help help={message} />
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }

    renderBalance = () => {
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-12 col-md-8">
                        <div className="showtix-form__group is-inline">
                            <label className="showtix-label" htmlFor="date">{strings.throughDate}</label>
                            <div className="showtix-form__input">
                                <SingleDatePickerWrapper 
                                    name="date" 
                                    id="date"
                                    disableFuture={true}
                                    handleDayChange={this.handleDayChange}
                                    selectedDays=""
                                />
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="showtix__balance">
                    <div className="row">
                        <div className="col-12 col-md-8">
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className="showtix__one-balance is-large">
                                        <div className="showtix__one-balance__title">{strings.totalBalance}</div>
                                        {
                                            new Intl.NumberFormat('en-US', {
                                                style: 'currency',
                                                currency: 'USD'
                                            })
                                            .format(this.state.total_balance)
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-md-4">
                                    <div className="showtix__one-balance">
                                        <div className="showtix__one-balance__title">{strings.activeFunds}</div>
                                        {
                                            new Intl.NumberFormat('en-US', {
                                                style: 'currency',
                                                currency: 'USD'
                                            })
                                            .format(this.state.active_balance + this.state.donation_balance)
                                        }
                                    </div>
                                </div>
                                {this.state.hasStripeConnect && (
                                    <div className="col-12 col-md-4">
                                        <div className="showtix__one-balance">
                                            <div className="showtix__one-balance__title">{strings.futurePayouts}</div>
                                            {
                                                new Intl.NumberFormat('en-US', {
                                                    style: 'currency',
                                                    currency: 'USD'
                                                })
                                                .format(this.state.future_payout_balance)
                                            }
                                        </div>
                                    </div>
                                )}
                                {this.state.hasStripeConnect && (
                                    <div className="col-12 col-md-4">
                                        <div className="showtix__one-balance">
                                            <div className="showtix__one-balance__title">{strings.inTransit}</div>
                                            {
                                                new Intl.NumberFormat('en-US', {
                                                    style: 'currency',
                                                    currency: 'USD'
                                                })
                                                .format(this.state.in_transit_balance)
                                            }
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            {strings.tips.map((help, i) =>
                                <Help help={help} key={i} />
                            )}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    renderPayoutButton = () => {
        if (this.state.client.billing_country !== 'CA') {
            return (
                <button
                    className={`showtix-button ${this.state.activeTab === 'payouts' ? 'showtix-background__primary-1' : 'showtix-background__primary-3'}`}
                    onClick={() => this.loadPayouts()}
                    disabled={this.state.message.type === 'loading'}
                >
                    <span>{strings.payouts}</span>
                </button>
            );
        } else {
            if (this.state.client.billing_country === 'CA') {
                if (this.state.client.payout_option !== 'check-at-close' && this.state.client.payout_option !== 'bill-com-ach') {
                    return (
                        <button
                            className={`showtix-button ${this.state.activeTab === 'payouts' ? 'showtix-background__primary-1' : 'showtix-background__primary-3'}`}
                            onClick={() => this.loadPayouts()}
                            disabled={this.state.message.type === 'loading'}
                        >
                            <span>{strings.payouts}</span>
                        </button>
                    )
                }
            }
        }
    }

    renderActivity = () => {
        return (
            <div className="showtix-section showtix-background__primary-1">
                <div className="container">
                    <h2>{strings.activity}</h2>

                    <div className="row">
                        <div className="col-12">
                            <div className="mb-2 d-flex showtix-buttons">
                                <button
                                    className={`showtix-button ${this.state.activeTab === 'active-funds' ? 'showtix-background__primary-1' : 'showtix-background__primary-3'}`}
                                    onClick={() => this.loadActiveFunds()}
                                    disabled={this.state.message.type === 'loading'}
                                >
                                    <span>{strings.activeFunds}</span>
                                </button>
                                {this.renderPayoutButton()}
                            </div>
                            
                            {this.renderActiveFunds()}
                            {this.renderPayouts()}
                            {this.renderPayoutsCheck()}
                            {this.renderBill()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderActiveFunds = () => {
        if (this.state.activeTab === 'active-funds') {
            const events = this.state.events;
            const flexpasses = this.state.flexpasses;
            return (
                <table className="showtix-table showtix-table__striped">
                    <thead>
                        <tr>
                            <th>{strings.eventName}</th>
                            <th>{strings.type}</th>
                            <th>{strings.amount}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            className="showtix-table__tr-clickable"
                        >
                            <td>
                                <button
                                    onClick={() => this.getDonationsReport()}
                                >
                                    {strings.donation}
                                </button>
                            </td>
                            <td>{strings.donationBalance}</td>
                            <td>
                                {
                                    new Intl.NumberFormat('en-US', {
                                        style: 'currency',
                                        currency: 'USD'
                                    })
                                    .format(this.state.donation_balance)
                                }
                            </td>
                        </tr>
                        {events.map((event) => (
                            <tr
                                className="showtix-table__tr-clickable"
                                key={event.id}
                            >
                                <td>
                                    <button
                                        onClick={() => this.getAccountEventReport(event.id, event.event_type === 'Flexpass' ? 'flexpass' : 'event' )}
                                    >
                                        {event.name}
                                    </button>
                                </td>
                                <td>
                                    {event.totals.withdrawals > 0 ? (
                                        <React.Fragment>{strings.reserve}</React.Fragment>
                                    ) : (
                                        <React.Fragment>{strings.activeEvent}</React.Fragment>
                                    )}
                                </td>
                                <td>
                                    {
                                        new Intl.NumberFormat('en-US', {
                                            style: 'currency',
                                            currency: 'USD'
                                        })
                                        .format(event.totals.event_balance)
                                    }
                                </td>
                            </tr>
                        ))}

                        {flexpasses.map((flexpass) => (
                            <tr
                                className="showtix-table__tr-clickable"
                                key={flexpass.id}
                            >
                                <td>
                                    <button
                                        onClick={() => this.getAccountEventReport(flexpass.id, 'flexpass')}
                                    >
                                        {flexpass.name}
                                    </button>
                                </td>
                                <td>
                                    {strings.flexpass}
                                </td>
                                <td>
                                    {
                                        new Intl.NumberFormat('en-US', {
                                            style: 'currency',
                                            currency: 'USD'
                                        })
                                        .format(flexpass.totals.flexpass_balance)
                                    }
                                </td>
                            </tr>
                        ))}
                        
                    </tbody>
                </table>
            );
        } else {
            return false;
        }
    }

    renderPayouts = () => {
        if (this.state.activeTab === 'payouts') {
            const payouts = this.state.payouts;
            if (payouts.length > 0) {
                return (
                    <React.Fragment>
                        <h3>{strings.electronicDeposit}</h3>
                        <table className="showtix-table showtix-table__striped">
                            <thead>
                                <tr>
                                    <th>{strings.type}</th>
                                    <th>{strings.status}</th>
                                    <th>{strings.initiatedDate}</th>
                                    <th>{strings.arrivalDate}</th>
                                    <th>{strings.amount}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {payouts.map((payout, index) => (
                                    <React.Fragment>
                                        <tr
                                            className={"showtix-payout " + (payout.isOpen && 'is-open')}
                                            key={payout.id}
                                        >
                                            <td>
                                                <button
                                                    className="showtix-payout__toggle"
                                                    onClick={() => this.loadPayoutInfo(payout, index)}
                                                >
                                                    
                                                </button>
                                                {payout.type}
                                            </td>
                                            <td>
                                                {payout.status}
                                            </td>
                                            <td>
                                                {moment(payout.created.substring(0, 19)).format('ll')}
                                            </td>
                                            <td>
                                                {moment(payout.arrival_date.substring(0, 19)).format('lll')}
                                            </td>
                                            <td>
                                                {
                                                    new Intl.NumberFormat('en-US', {
                                                        style: 'currency',
                                                        currency: 'USD'
                                                    })
                                                    .format(payout.amount)
                                                }
                                            </td>
                                        </tr>
                                        {payout.isOpen && (
                                            <tr className="showtix-payout__info">
                                                <td colspan="5">
                                                    {(payout.withdrawals && payout.withdrawals.length > 0) && (
                                                        <React.Fragment>
                                                            <h4>{strings.withdrawals}</h4>
                                                            <table className="showtix-table showtix-table__striped">
                                                                <thead>
                                                                    <tr>
                                                                        <th>{strings.event}</th>
                                                                        <th>{strings.memo}</th>
                                                                        <th>{strings.date}</th>
                                                                        <th>{strings.amount}</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {payout.withdrawals.map((withdrawal) => (
                                                                        <tr>
                                                                            <td>
                                                                                <a
                                                                                    href="#"
                                                                                    onClick={() => this.getAccountEventReport(withdrawal.event_id === 0 ? withdrawal.flexpass_id : withdrawal.event_id, withdrawal.event_id === 0 ? 'flexpass' : 'event' )}>
                                                                                        {withdrawal.event_name}
                                                                                    </a>
                                                                            </td>
                                                                            <td>
                                                                                {withdrawal.memo === 'Stripe Account Transfer' ? (
                                                                                    <React.Fragment>
                                                                                        Donation Transfer
                                                                                    </React.Fragment>
                                                                                ) : (
                                                                                    <React.Fragment>
                                                                                        {withdrawal.memo}
                                                                                    </React.Fragment>
                                                                                )}
                                                                            </td>
                                                                            <td>
                                                                                {moment(withdrawal.datetime.substring(0, 19)).format('lll')}
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    new Intl.NumberFormat('en-US', {
                                                                                        style: 'currency',
                                                                                        currency: 'USD'
                                                                                    })
                                                                                    .format(withdrawal.amount)
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </React.Fragment>
                                                    )}
                                                    {(payout.transactions && payout.transactions.length > 0) && (
                                                        <React.Fragment>
                                                            <h4>{strings.transactions}</h4>
                                                            <table className="showtix-table showtix-table__striped">
                                                                <thead>
                                                                    <tr>
                                                                        <th>{strings.type}</th>
                                                                        <th>{strings.tx}</th>
                                                                        <th>{strings.date}</th>
                                                                        <th>{strings.amount}</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {payout.transactions.map((transaction) => (
                                                                        <tr>
                                                                            <td>
                                                                                POS
                                                                            </td>
                                                                            <td>
                                                                                <a target="_blank" href={`/search/transaction/${transaction.id}`}>
                                                                                    {transaction.id}
                                                                                </a>
                                                                            </td>
                                                                            <td>
                                                                                {moment(transaction.creation_date.substring(0, 19)).format('lll')}
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    new Intl.NumberFormat('en-US', {
                                                                                        style: 'currency',
                                                                                        currency: 'USD'
                                                                                    })
                                                                                    .format(transaction.txn_gross)
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </React.Fragment>
                                                    )}
                                                </td>
                                            </tr> 
                                        )}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                        <div className="mt-2 d-flex showtix-buttons">
                            <button
                                className={`showtix-button showtix-button__small showtix-background__primary-1`}
                                onClick={() => this.loadPayouts(this.state.payouts.length, -1)}
                                disabled={this.state.message.type === 'loading'}
                            >
                                <span>{strings.previousPage}</span>
                            </button>
                            <button
                                className={`showtix-button showtix-button__small showtix-background__primary-1`}
                                onClick={() => this.loadPayouts(this.state.payouts.length, 1)}
                                disabled={this.state.message.type === 'loading'}
                            >
                                <span>{strings.nextPage}</span>
                            </button>
                        </div>
                    </React.Fragment>
                    
                );
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    renderPayoutDate = (payoutCheck, index) => {
        if (payoutCheck.statusCode !== '1' && payoutCheck.statusCode !== '3') {
            return (
                <a
                    href="#"
                    onClick={() => this.getBill(index)}>
                    {moment(payoutCheck.createdTime.substring(0, 19)).format('llll')}
                </a>
            );
        } else {
            return (
                moment(payoutCheck.createdTime.substring(0, 19)).format('llll')
            );
        }
    }

    renderPayoutsCheck = () => {
        if (this.state.activeTab === 'payouts') {
            const payoutsCheck = this.state.payoutsCheck;
            return (
                <div className="mt-3">
                    <hr />
                    <h3>{strings.check}</h3>
                    <div className="row">
                        
                        <div className="col-12 col-md-4">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="max">{strings.max}</label>
                                <div className="showtix-form__select">
                                    <select
                                        className="showtix-input"
                                        value={this.state.maxCheck}
                                        onChange={e => this.handleMaxSelect(e)}
                                        id="max"
                                    >
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="75">75</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="startCheck">{strings.startCheck}</label>
                                <div className="showtix-form__select">
                                    <select
                                        className="showtix-input"
                                        value={this.state.startCheck}
                                        onChange={e => this.handleStartSelect(e)}
                                        id="startCheck"
                                    >
                                        {[...Array(10).keys()].map((value) => (
                                            <option value={value}>{value+1}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <p><br /></p>
                            <button
                                className="showtix-button showtix-background__primary-2"
                                onClick={this.loadPayoutsCheck}
                            >
                                {strings.apply}
                            </button>
                        </div>
                    </div>
                    {payoutsCheck.length > 0 && (
                        <table className="mt-3 showtix-table showtix-table__striped">
                            <thead>
                                <tr>
                                    <th
                                        onClick={() => this.sort('createdTime')}
                                        data-direction={this.state.sortAsc ? `asc` : `des`}
                                        className={this.state.sort === 'createdTime' ? `showtix-sort is-active` : `showtix-sort`}
                                    >
                                        {strings.createdTime}
                                    </th>
                                    <th onClick={() => this.sort('amount')}
                                        data-direction={this.state.sortAsc ? `asc` : `des`}
                                        className={this.state.sort === 'amount' ? `showtix-sort is-active` : `showtix-sort`}
                                    >
                                        {strings.amount}
                                    </th>
                                    <th>{strings.paymentType}</th>
                                    <th>{strings.status}</th>
                                    <th>{strings.description}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {payoutsCheck.map((payoutCheck, index) => (
                                    <React.Fragment>
                                        <tr
                                            className="showtix-payout"
                                            key={payoutCheck.id}
                                        >
                                            <td>
                                                {this.renderPayoutDate(payoutCheck, index)}
                                            </td>
                                            <td>
                                                {payoutCheck.status === 'void' ? (
                                                    <React.Fragment>
                                                    {
                                                        new Intl.NumberFormat('en-US', {
                                                            style: 'currency',
                                                            currency: 'USD'
                                                        })
                                                        .format(0)
                                                    }
                                                </React.Fragment>
                                                ) : (
                                                    <React.Fragment>
                                                        {
                                                            new Intl.NumberFormat('en-US', {
                                                                style: 'currency',
                                                                currency: 'USD'
                                                            })
                                                            .format(payoutCheck.amount)
                                                        }
                                                    </React.Fragment>
                                                )}
                                            </td>
                                            <td>
                                                {payoutCheck.paymentType ? (
                                                    <React.Fragment>
                                                        {payoutCheck.paymentType }
                                                    </React.Fragment>
                                                ) : (
                                                    <React.Fragment>
                                                        {strings.electronicDeposit}
                                                    </React.Fragment>
                                                )}
                                            </td>
                                            <td>
                                                <span className='showtix-badge showtix-background__primary-1'>
                                                    {payoutCheck.status}
                                                </span>
                                            </td>
                                            <td>
                                                {payoutCheck.description.replace('Inv #N/A-- ', '').replace('bill.com ', '')}
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            );
        } else {
            return false;
        }
    }
    
    renderStatusDate = (selectedPayout) => {
        if (selectedPayout.disbursementData.disbursementStatus === 'scheduled') {
            return (
                <React.Fragment>
                    <span id={`tooltip-scheduled-${selectedPayout.id}`} className="showtix-badge showtix-background__grey-4">?</span>
                    <Tooltip placement="top" target={`tooltip-scheduled-${selectedPayout.id}`}>
                        {strings.scheduled}
                    </Tooltip>
                </React.Fragment>
            );
        }

        if (selectedPayout.disbursementData.checkData.clearedDate) {
            return (
                <React.Fragment>
                    {selectedPayout.disbursementData.checkData.clearedDate}
                    <span id={`tooltip-cleared-${selectedPayout.id}`} className="showtix-badge showtix-background__grey-4">?</span>
                    <Tooltip placement="top" target={`tooltip-cleared-${selectedPayout.id}`}>
                        {strings.clearedDate}
                    </Tooltip>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    {selectedPayout.disbursementData.checkData.arrivesByDate}
                    <span id={`tooltip-arrives-${selectedPayout.id}`} className="showtix-badge showtix-background__grey-4">?</span>
                    <Tooltip placement="top" target={`tooltip-arrives-${selectedPayout.id}`}>
                        {strings.arrivesByDate}
                    </Tooltip>
                </React.Fragment>
            );
        }
    }

    renderStatus = (selectedPayout) => {
        if (selectedPayout.disbursementData.disbursementStatus === 'void') {
            return (
                <React.Fragment>
                    <span id={`tooltip-void-${selectedPayout.id}`} className="showtix-badge showtix-background__primary-3">{strings.void}</span>
                    <Tooltip placement="top" target={`tooltip-void-${selectedPayout.id}`}>
                        {selectedPayout.disbursementData.reason}
                    </Tooltip>
                </React.Fragment>
            );
        }

        if (selectedPayout.disbursementData.disbursementStatus === 'scheduled') {
            return (
                <span className='showtix-badge showtix-background__primary-1'>
                    {strings.scheduled}
                </span>
            );
        }

        if (selectedPayout.disbursementData.disbursementStatus === 'not-cleared') {
            return (
                <span className='showtix-badge showtix-background__grey-4'>
                    {strings.notCleared}
                </span>
            );
        }

        if (selectedPayout.disbursementData.disbursementStatus === 'cleared') {
            return (
                <span className='showtix-badge showtix-background__primary-1'>
                    {strings.cleared}
                </span>
            );
        } else {
            if (selectedPayout.disbursementData.checkData.clearedDate && selectedPayout.disbursementData.disbursementStatusCode === '3') {
                return (
                    <React.Fragment>
                        <span id={`tooltip-notcleared-${selectedPayout.id}`} className="showtix-badge showtix-background__grey-4">{strings.notCleared}</span>
                        <Tooltip placement="top" target={`tooltip-notcleared-${selectedPayout.id}`}>
                            {strings.expiresOn} {selectedPayout.disbursementData.checkData.expirationDate}
                        </Tooltip>
                    </React.Fragment>
                );
            } else {
                return null;
            }
        }

        
    }

    renderBill = () => {
        let selectedBill = this.state.selectedBill;
        let payoutsCheck = this.state.payoutsCheck;
        let hasBillLineItems = false;
        let title = '';
        if (this.state.isPaymentDetailsOpen) {
            if (selectedBill !== -1) {
                console.log('payoutCheck', payoutsCheck);
                console.log('selectedBill', selectedBill);
                console.log('payoutsCheck[selectedBill]', payoutsCheck[selectedBill])
                title = payoutsCheck[selectedBill].disbursementData ? payoutsCheck[selectedBill].disbursementData.checkData.checkNumber : '';
                payoutsCheck[selectedBill].billPays.forEach((billPay) => {
                    if (billPay.bill.billLineItems.length > 0) {
                        hasBillLineItems = true;
                    }
                });
            }
            return (
                <Modal className="modal-lg" isOpen={this.state.isPaymentDetailsOpen} toggle={this.togglePaymentDetailsModal}>
                    <ModalHeader toggle={this.togglePaymentDetailsModal}>{strings.paymentDetails} - {title}</ModalHeader>
                    <ModalBody className="text-left">
                        {this.state.isModalLoading ? (
                            <div className="showtix-loader">Loading...</div>
                        ) : (
                            <React.Fragment>
                                <div className="row mb-3">
                                    {payoutsCheck[selectedBill].disbursementData.checkData ? (
                                        <React.Fragment>
                                            <div className="col-12 col-md-3">
                                                <h4>{strings.checkNumber}</h4>
                                                {payoutsCheck[selectedBill].disbursementData && (
                                                    <React.Fragment>
                                                        {payoutsCheck[selectedBill].disbursementData.checkData.checkNumber}
                                                    </React.Fragment>
                                                )}
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <h4>{strings.amount}</h4>
                                                {payoutsCheck[selectedBill].disbursementData.disbursementStatus === 'void' ? (
                                                    <React.Fragment>
                                                        {
                                                            new Intl.NumberFormat('en-US', {
                                                                style: 'currency',
                                                                currency: 'USD'
                                                            })
                                                            .format(0)
                                                        }
                                                    </React.Fragment>
                                                ) : (
                                                    <React.Fragment>
                                                        {
                                                            new Intl.NumberFormat('en-US', {
                                                                style: 'currency',
                                                                currency: 'USD'
                                                            })
                                                            .format(payoutsCheck[selectedBill].amount)
                                                        }
                                                    </React.Fragment>
                                                )}
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <h4>{strings.statusDate}</h4>
                                                {this.renderStatusDate(payoutsCheck[selectedBill])}
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <h4>{strings.status}</h4>
                                                {!payoutsCheck[selectedBill].disbursementData.checkData.errorCode ? (
                                                    <React.Fragment>
                                                        {this.renderStatus(payoutsCheck[selectedBill])}
                                                    </React.Fragment>
                                                ) : (
                                                    <React.Fragment>
                                                        {payoutsCheck[selectedBill].disbursementData.checkData.errorCode === 'E01' && (
                                                            <span className='showtix-badge showtix-background__error'>
                                                                {strings.expired}
                                                            </span>
                                                        )}
                                                        {payoutsCheck[selectedBill].disbursementData.checkData.errorCode === 'E02' && (
                                                            <span className='showtix-badge showtix-background__error'>
                                                                {strings.returned}
                                                            </span>
                                                        )}
                                                    </React.Fragment>
                                                )}
                                            </div>
                                            {payoutsCheck[selectedBill].disbursementData.checkData.trackingInfo && (
                                                <div className="col-12 col-md-3 mt-3">
                                                    <h4>{strings.trackingInfo}</h4>
                                                    <a href={payoutsCheck[selectedBill].disbursementData.checkData.trackingUrl} target="_blank">{payoutsCheck[selectedBill].disbursementData.checkData.trackingInfo}</a>
                                                </div>
                                            )}
                                            <div className="col-12 col-md-3 mt-3">
                                                <h4>{strings.address}</h4>
                                                {payoutsCheck[selectedBill].disbursementData.address1}<br />
                                                {payoutsCheck[selectedBill].disbursementData.address2}<br />
                                                {payoutsCheck[selectedBill].disbursementData.addressCity}, {payoutsCheck[selectedBill].disbursementData.addressState}, {payoutsCheck[selectedBill].disbursementData.addressCountry}<br />
                                                {payoutsCheck[selectedBill].disbursementData.addressZip}
                                            </div>
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            <div className="col-12 col-md-4">
                                                <h4>{strings.depositDate}</h4>
                                                {payoutsCheck[selectedBill].disbursementData && (
                                                    <React.Fragment>
                                                        {payoutsCheck[selectedBill].disbursementData.walletData.depositDate}
                                                    </React.Fragment>
                                                )}
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <h4>{strings.amount}</h4>
                                                {payoutsCheck[selectedBill].disbursementData && (
                                                    <React.Fragment>
                                                        {
                                                            new Intl.NumberFormat('en-US', {
                                                                style: 'currency',
                                                                currency: 'USD'
                                                            })
                                                            .format(payoutsCheck[selectedBill].amount)
                                                        }
                                                    </React.Fragment>
                                                )}
                                            </div>
                                        </React.Fragment>
                                    )}
                                    
                                </div>

                                {payoutsCheck[selectedBill].images && (
                                    <div className="row">
                                        <div className="col-12">
                                            <h4>{strings.checkImages}</h4>
                                            <div className="showtix-check-images">
                                                {payoutsCheck[selectedBill].images.map((image, image_index) => (
                                                    <a download={`check_image_${image_index}.png`} href={'data:application/octet-stream;base64,' + image.split('base64,')[1]} target="_blank">
                                                        <img src={image} className="img-responsive" />
                                                    </a>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <h4>{strings.paymentDetails}</h4>
                                {hasBillLineItems ? (
                                    <React.Fragment>
                                        <table className="showtix-table showtix-table__striped">
                                            <thead>
                                                <tr>
                                                    <th>{strings.invoiceDate}</th>
                                                    <th>{strings.amount}</th>
                                                    <th>{strings.description}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {payoutsCheck[selectedBill].billPays.map((billPay) => (
                                                    billPay.bill.billLineItems.map((billLineItem, index) => (
                                                        <React.Fragment>
                                                            <tr
                                                                className="showtix-payout"
                                                                key={billLineItem.id}
                                                            >
                                                                <td>
                                                                    {moment(billLineItem.createdTime.substring(0, 19)).format('llll')}
                                                                </td>
                                                                <td>
                                                                    {payoutsCheck[selectedBill].disbursementData.disbursementStatus === 'void' ? (
                                                                        <React.Fragment>
                                                                            {
                                                                                new Intl.NumberFormat('en-US', {
                                                                                    style: 'currency',
                                                                                    currency: 'USD'
                                                                                })
                                                                                .format(0)
                                                                            }
                                                                        </React.Fragment>
                                                                    ) : (
                                                                        <React.Fragment>
                                                                            {
                                                                                new Intl.NumberFormat('en-US', {
                                                                                    style: 'currency',
                                                                                    currency: 'USD'
                                                                                })
                                                                                .format(billLineItem.amount)
                                                                            }
                                                                        </React.Fragment>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {billLineItem.description}
                                                                </td>
                                                            </tr>
                                                        </React.Fragment>
                                                    ))
                                                ))}
                                            </tbody>
                                        </table>
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                        No payment details.
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <button 
                            className="showtix-button showtix-background__grey-1"
                            onClick={this.togglePaymentDetailsModal}
                        >
                            {strings.close}
                        </button>
                    </ModalFooter>
                </Modal>
            );
        } else {
            return false;
        }
    }

    renderEventHistoryReport = () => {
        return (
            <div className="showtix-section showtix-background__primary-1">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <button
                                className="showtix-button showtix-background__primary-2"
                                onClick={this.getEventHistory}
                            >
                                {strings.eventHistory}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
		return (
            <React.Fragment>
                <div className="showtix-section container">
                    <div className="row">
                        <div className="col-12">
                            <h1>{strings.title}</h1>
                            <Message
                                message={this.state.message}
                            />
                            {this.renderW9Message()}
                            {this.renderBalance()}
                        </div>
                    </div>
                </div>
                {this.renderActivity()}

                {this.renderEventHistoryReport()}
            </React.Fragment>
		);
  	}
}

export default AccountBalance;


// WEBPACK FOOTER //
// ./src/components/AccountBalance/AccountBalance.js